
import { TypedTable } from "@/components/ui/table/TypedTable";
import { createColumnHelper, tableFeatures } from "@tanstack/react-table";
import type { DBPrioritaria } from "../SincroAlmacen";
import { useLogsLinea, type LogSincro } from "./ModalLogSincro";
import { useMemo } from "react";
import { CommonFeatures } from "@/hooks/useTanstackTable";

export function TablaLogSincro(props: { readonly idLogCabSincro: number | null; }) {
	const { data, error, isPending } = useLogsLinea(props.idLogCabSincro);

	const { columns, features } = useMemo(() => Columns(), []);

	if (data === null) return <div>Selecciona un log de sincronización</div>;

	return (
		<TypedTable
			// "scrollY": "400px",
			// "scrollCollapse": true,
			className="dataTable display"
			features={features}
			columns={columns}
			data={data ?? []}

			noResultsMessage="No se encontraron sincronizaciones"
			errorMessage="Error al cargar los datos"
			isLoading={isPending}
			isError={error != null}
		/>
	);
}





function Columns() {
	const columnHelper = createColumnHelper<typeof features, LogSincro>();
	const features = tableFeatures(CommonFeatures);

	const columns = columnHelper.columns([
		columnHelper.accessor("prioritaria", { header: "Direccion", meta: { className: "dt-center" }, cell: info => prioritariaADireccion(info.getValue()) }),
		columnHelper.accessor("almacen_id", { header: "Almacén", meta: { className: "dt-center" } }),
		columnHelper.accessor("articulo_id", { header: "Artículo", meta: { className: "dt-center" } }),
		// columnHelper.accessor(row => "WIP: SUMA", { header: "Tipo", meta: { className: "dt-center" } }),
		columnHelper.accessor("cantidad_sumar", { header: "Cantidad", meta: { className: "dt-center" } }),
	]);
	return { columns, features };
}

function prioritariaADireccion(prioritaria: DBPrioritaria) {
	if (prioritaria == "EKON") return "EKON>MRP";
	else return "MRP>EKON";
}